module.exports = __webpack_public_path__ + "img/littleImg04.3a077943.gif";